import React from "react";
import PropTypes from 'prop-types';
import './ModalWarning.scss';

export default function ModalWarning(props) {
  return (
    <div className="warning-box">
      <span className="lighter-font">{props.message}</span>
    </div>
  )
}

ModalWarning.propTypes = {
  message: PropTypes.string.isRequired,
}
